import React from "react";
import { Button } from "semantic-ui-react";

interface Props {
  uploadedFile: UploadedFileData
  onFileRemoved: () => void

  onSign: (guid: string) => Promise<any>
}

export interface UploadedFileData {
  url: string
  guid: string
}

const UploadSignatureFile = (props: Props) => {
  const [isLoading, setIsLoading] = React.useState<boolean>(false);

  const onStartSigning = async () => {
    setIsLoading(true);
    try {
      await props.onSign(props.uploadedFile.guid);
    } catch {
      setIsLoading(false);
    }
  };

  return <>
    <div className="upload-signature-file" style={{ textAlign: "center" }}>
      <img src={props.uploadedFile.url} style={{ maxHeight: 150 }} />
    </div>

    <div className="flex margin-top-small">
      <div className="grow1">
        <a onClick={props.onFileRemoved}>clear</a>
      </div>
      <Button
        primary
        loading={isLoading}
        onClick={onStartSigning}
        content={RESX.ESign.SignNow}
        disabled={isLoading}
        icon="right arrow"
        labelPosition="right"
      />
    </div>
  </>;
};

export default UploadSignatureFile;